import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Table, Icon, Row, Col, Popconfirm, Select, Divider, Switch, Input, Button } from 'antd';
import { Animated } from "react-animated-css";
import HeaderContent from '../common/headercontent/HeaderContent';
import AddSchoolListModal from './modal/AddSchoolListModal';
import moment from 'moment';
import Highlighter from 'react-highlight-words';
import { yearFrom, yearTo } from './../../config';

import './schoollist.css';

import {
  schoolList,
  schoolDelete,
} from '../../modules/school';
import {
  studentList,
} from '../../modules/student';
const { Option } = Select;

class SchoolList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addModal: false,
      selectedSchoolList: null,
      year: (new Date).getMonth() < 8 ? `${parseInt(moment(new Date).format('YYYY'), 10) - 1} - ${moment(new Date).format('YYYY')}` : `${moment(new Date).format('YYYY')} - ${parseInt(moment(new Date).format('YYYY'), 10) + 1}`,
      showAll: true,
      loadingSchoolList: false,
      loadingStudents: false,
      searchText: '',
      searchedColumn: '',
      students: [],
    }
    this.yearList = [];
    for (let i = yearFrom; i <= yearTo; i++) {
      this.yearList.push(`${i} - ${i + 1}`);
    }
  }

  componentDidMount() {
    this.getSchoolList();
    this.getStudentList();
  }

  toggleAddModal = () => {
    const { addModal } = this.state;
    if (addModal) {
      this.setState({ selectedSchoolList: null });
    }
    this.setState({ addModal: !addModal });
  }

  onSelectSchoolList(schoolId = null) {
    window.scrollTo(0, 0);
    this.setState({ selectedSchoolList: null });
    setImmediate(() => {
      this.setState({ selectedSchoolList: schoolId });
    });
  }

  getSchoolList() {
    this.setState({ loadingSchoolList: true });
    this.props.schoolList().then(
      () => {
        this.setState({ loadingSchoolList: false });
      },
      () => {
        this.setState({ loadingSchoolList: false, message: `Can't get through. Please try again later or contact the administrator.` });
      }
    );
  }

  getStudentList() {
    this.setState({ loadingStudents: true });
    this.props.studentList().then(
      (res) => {
        this.setState({ students: res.results, loadingStudents: false });
      },
      () => {
        this.setState({ loadingStudents: false, message: `Can't get through. Please try again later or contact the administrator.` });
      }
    );
  }

  onDeleteConfirm(schoolId) {
    const { selectedSchoolList } = this.state;

    this.props.schoolDelete(schoolId).then(
      (res) => {
        if (schoolId === selectedSchoolList) {
          this.setState({ selectedSchoolList: null });
        }
        this.getSchoolList();
      },
      (err) => {
        this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
      }
    );
  }

  onPageChange(page, pageSize) {
    this.schoolListChange(page, pageSize);
  }

  onPageSizeChange(current, pageSize) {
    this.schoolListChange(current, pageSize);
  }

  onEditSchoolList = (selected) => {
    this.setState({ selectedSchoolList: selected });
    this.toggleAddModal();
  }

  onChangeSchool = (checked) => {
    this.setState({ showAll: checked });
  }

  getColumnSearchProps = (dataIndex, displayName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`搜尋${displayName}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          搜尋
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          重設
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {

    const { addModal, selectedSchoolList, year, showAll, students, loadingSchoolList, loadingStudents } = this.state;
    console.log(this.props)
    const loading = loadingSchoolList || loadingStudents;

    const columns = [{
      title: '編號',
      dataIndex: 'schoolId',
      key: 'schoolId',
      ...this.getColumnSearchProps('schoolId', '編號'),
    }, {
      title: '學校(中文)',
      dataIndex: 'name_tc',
      key: 'name_tc',
      ...this.getColumnSearchProps('name_tc', '學校(中文)'),
    }, {
      title: '學校(英文)',
      dataIndex: 'name_en',
      key: 'name_en',
      ...this.getColumnSearchProps('name_en', '學校(英文)'),
    }, {
      title: 'CLASS數量',
      dataIndex: 'class',
      key: 'class',
    }, {
      title: '學生數量',
      dataIndex: 'quotaSum',
      key: 'quotaSum',
    }, {
      title: '問卷數量',
      dataIndex: 'studentDone',
      key: 'studentDone',
    }, {
      title: 'ADMIN數量',
      dataIndex: 'admin',
      key: 'admin',
    }, {
      title: '狀態',
      dataIndex: 'status',
      key: 'status',
      render: (text, data) => {
        return (text === 'active' ? '正常' : '已凍結');
      },
      filters: [{ text: '正常', value: 'active' }, { text: '已凍結', value: 'inactive' }],
      filterMultiple: false,
      onFilter: (value, record) => record.status.indexOf(value) === 0,
    }, {
      title: '操作',
      key: '操作',
      render: (text, data) => (
        <span>
          <a onClick={() => this.onEditSchoolList(data)}>編輯</a>
        </span>
      ),
    }
    ];

    const headerData = {
      button: {
        title: <span><Icon type="file-add" /> 新增學校</span>,
        function: () => this.toggleAddModal()
      }
    };

    const headerSSchoolListData = (selectedSchoolList) ? {
      close: {
        title: <Icon type="close-square" />,
        function: () => this.onSelectSchoolList()
      }
    } : "";

    let data = [];
    let sSchoolList = [];
    if (this.props.schoolData) {
      data = this.props.schoolData.results.map(school => {
        return {
          _id: school._id,
          schoolId: school.schoolId.toString().padStart(3, '0'),
          name_tc: school.name_tc,
          name_en: school.name_en,
          status: school.status,
          admin: 0,
          class: school.class.filter(c => c.year === year && c.status === 'active').length,
          admin: school.admin.length,
          quotaSum: school.class.map((c => {
            if (c.year === year && c.status === 'active') return c.quota;
            else return 0;
          })).reduce((a, b) => a + b, 0),
          studentDone: students.filter(s => school.class.map(c => c._id).indexOf(s.classData.schoolQuotaId) > -1 && s.progress === 'done' && s.schoolQuota.year === year).length,
        }
      });

      if (!showAll) {
        data = data.filter(d => d.class > 0);
      }

      sSchoolList = this.props.schoolData.results.filter(school => school._id === selectedSchoolList);
    }

    return (
      <Animated animationIn="fadeIn">
        <div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
          <Row>
            <Col>
              <HeaderContent title="學校名單/資訊" subtitle="學校名單/資訊" data={headerData} />
              <Card title={<p><span>學校名單 </span></p>}>
                <span>
                  <Select
                    defaultValue={year}
                    style={{ width: 140, marginBottom: 30 }}
                    onChange={(v) => { this.setState({ year: v }) }}
                  >
                    {
                      this.yearList.map(y => <Option value={y}>{y}</Option>)
                    }
                  </Select>
                  <span style={{ margin: '0 10px 0 20px' }}>顯示全部學校:</span>
                  <Switch defaultChecked onChange={this.onChangeSchool.bind(this)} />
                </span>
                <Table columns={columns} dataSource={data} loading={loading} />
              </Card>

              <AddSchoolListModal
                show={addModal}
                toggleAddModal={this.toggleAddModal.bind(this)}
                selected={selectedSchoolList}
              />
            </Col>
          </Row>
        </div>
      </Animated>
    );
  }
}

const mapStateToProps = state => ({
  router: state.router,
  schoolData: state.school.data,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      schoolList,
      schoolDelete,
      studentList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SchoolList);
